<template>
  <div>
    <date-picker v-if="$i18n.locale=='fa'"
        :label="$t('month')"
                 display-format="jMM jMMMM"
                 type="month"
                 input-format="YYYY-MM-DD"
                 :auto-submit="true"

        v-model="state">
    </date-picker>
    <date-picker v-else
        :label="$t('month')"
                 display-format="MM MMMM"
                 type="month"
                 input-format="YYYY-MM-DD"
                 :auto-submit="true"

        v-model="state">
    </date-picker>
  </div>

</template>

<script>
    import CFormGroup from '@coreui/vue/src/components/form/CFormGroup'
    import { inputProps as props } from '@coreui/vue/src/components/form/form-props'
    import * as allFormMixins from '@coreui/vue/src/components/form/form-mixins'
    const mixins = Object.values(allFormMixins)

    export default {
        name: 'CInput',

        inheritAttrs: false,
        components: {  },
        mixins,
        props,

        data () {
            return {
                state: this.value,
                syncTimeout: null
            }
        },
      watch:{
        'state':function (){
          console.log("month picker changed")
          this.$emit('update:value', this.state, null)
          this.$emit('change', this.state, null)

        }
      },
        computed: {
            listeners () {
                const { input, change, ...listeners } = this.$listeners // eslint-disable-line no-unused-vars
                return listeners
            }

        },
        methods: {
            onInput (e) {
                console.log("on input")
                this.state = (e.target.value)
                this.$emit('input', this.state, e)
                if (this.lazy === true) {
                    return
                }

                clearTimeout(this.syncTimeout)
                this.syncTimeout = setTimeout(() => {
                    // console.log("on lazy")

                    this.$emit('update:value', this.state, e)
                }, this.lazy !== false ? this.lazy : 0)
            },
            onChange (e) {
                // console.log("on change")

                this.state = (e.target.value)
                // this.$emit('input', this.state.replace(/,/g, ''), e)

                this.$emit('change', this.state, e)
                this.$emit('update:value', this.state, e)
            },
        },


    }
</script>
